import React from 'react'

export const useCountdown = (initialValue = 0): [number, React.Dispatch<React.SetStateAction<number>>] => {
  const [secondsLeft, setSecondsLeft] = React.useState(initialValue)

  React.useEffect(() => {
    if (secondsLeft <= 0) return
    const timer = setInterval(() => setSecondsLeft((s) => s - 1), 1000)
    return () => clearInterval(timer)
  }, [secondsLeft])

  return [secondsLeft, setSecondsLeft]
}
